var _path, _rect, _rect2, _rect3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayout6 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 160 90"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  d: "M0 0h160v90H0z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 6,
  x: 44,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 138,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 6,
  x: 6,
  y: 6,
  fill: "#CCC",
  rx: 3
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCC",
  d: "M82 18h72v3.65H82zM82 23.65h72v3.65H82zM82 29.3h72v3.65H82zM82 34.95h72v3.65H82zM82 40.6h72v3.65H82zM82 46.25h72v3.65H82zM82 51.9h72v3.65H82zM82 57.55h72v3.65H82zM82 63.2h72v3.65H82zM82 68.85h72v3.65H82zM82 74.5h72v3.65H82zM82 80.15h72v3.65H82zM6 18h72v3.65H6zM6 23.65h72v3.65H6zM6 29.3h72v3.65H6zM6 34.95h72v3.65H6zM6 40.6h72v3.65H6zM6 46.25h72v3.65H6zM6 51.9h72v3.65H6zM6 57.55h72v3.65H6zM6 63.2h72v3.65H6zM6 68.85h72v3.65H6zM6 74.5h72v3.65H6zM6 80.15h72v3.65H6z"
})));
export { SvgLayout6 as ReactComponent };